import { IAjaxCreationMethod } from '@microsoft/portal-app/lib/auth';
import { addAjaxEpic } from '@microsoft/portal-app/lib/redux/createAjaxEpic';
import { IRootUserState } from '@microsoft/portal-app/lib/User/models';
import { setUserPeopleInsightsSettingsRequest } from '../../../redux/modules/graphApis';
import { IPrivacyAction } from '../../models/IPrivacyActions';
import { IPrivacyState } from '../../models/IPrivacyState';
import { PrivacyActions } from '../../models/PrivacyActions';
import { privacyRegistry as registry } from '../privacyRegistry';

export const setPeopleInsightsStatusResponse = (
  state: IPrivacyState,
  action: IPrivacyAction<unknown>,
): IPrivacyState => {
  const didEnable = action.type === `${PrivacyActions.enablePeopleInsights}/success`;

  let peopleInsightsServiceStateValue = state.peopleInsightsServiceState.value;
  if (peopleInsightsServiceStateValue !== 'TenantOptedOut') {
    peopleInsightsServiceStateValue = didEnable ? 'Enabled' : 'UserOptedOut';
  }
  const nextState: IPrivacyState = {
    ...state,
    peopleInsightsServiceState: {
      ...state.peopleInsightsServiceState,
      value: peopleInsightsServiceStateValue,
    },
  };

  return nextState;
};

export const setPeopleInsightsStatusFailed = (state: IPrivacyState): IPrivacyState => {
  return state;
};

export const setPeopleInsights =
  (isEnabled: boolean) => (ajax: IAjaxCreationMethod, _action: IPrivacyAction, _state: IRootUserState) => {
    return ajax(
      setUserPeopleInsightsSettingsRequest({
        isEnabled,
        Scenario: {
          Name: 'MyAccount',
        },
      }),
    ).pipe();
  };

addAjaxEpic(registry, PrivacyActions.enablePeopleInsights, setPeopleInsights(true), {
  statePropertyName: 'peopleInsightsServiceState',
  loadingFailedReducer: setPeopleInsightsStatusFailed,
  loadingSuccessReducer: setPeopleInsightsStatusResponse,
});

addAjaxEpic(registry, PrivacyActions.disablePeopleInsights, setPeopleInsights(false), {
  statePropertyName: 'peopleInsightsServiceState',
  loadingFailedReducer: setPeopleInsightsStatusFailed,
  loadingSuccessReducer: setPeopleInsightsStatusResponse,
});
